export enum StatoClasse {
    aperta = 'APERTA',
    dapromuovere = 'DA_PROMUOVERE'
}
